import {Component, OnInit} from '@angular/core';
import {ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public constructor(private store: Store) {}

  public ngOnInit(): void {
    const classroom: ClassroomStateModel = this.store.selectSnapshot<ClassroomStateModel>(ClassroomState);

    window.location.href = classroom.newStudentPortalUrl + 'student-portal/login?target=' + window.location.origin + '/' + classroom.roomNum;
  }
}
